/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useCallback, useEffect, useRef, useState} from 'react'
import CloseLineIcon from 'remixicon-react/CloseLineIcon'

import cn from 'classnames'
import styled from 'styled-components'
import {media} from 'styled-bootstrap-grid'
import {palette} from 'styled-tools'

import {RadioButton} from 'src/components/form'
import {Expandable} from 'src/components/common'
import Loader from 'src/components/common/Loader'
import {theme} from 'src/themes'
import {Title6} from '../typography'
import {SortDropdown} from '../account/ordersOverview'

interface Props {
  title: string
  description?: React.ReactNode
  price?: string
  selected?: boolean
  onSelect: () => void
  icon?: React.ReactElement
  children?: React.ReactNode
  showDropDown?: boolean
  options?: any
  // mapBtn?: React.ReactNode
  droppDelivery?: boolean
  droppDeliveryId?: string
  locationId?: (location: any) => void
  mapDetail?: boolean
  setLocationInfo?: (info: any) => void
  updateDropDownLocationInfo?: (info: any) => void
  setSelectedDropLocation?: (info: any) => void
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
`
const Card = styled.div`
  position: relative;
  padding: 15px 15px 15px 15px;
  cursor: pointer;

  ${media.md`
    padding: 34px;
  `}

  margin: 16px 0;
  width: 100%;
  max-width: 700px;
  border: 1px solid ${palette('black')};
  background-color: ${palette('white')};

  &.selected {
    border: 1px solid ${palette('red')};
  }

  .btn-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: black;
    padding: 12px;
    .close_btn {
      color: white;
    }
    margin-top: 16px;
    &.selected {
      background-color: white;
      border: 1px solid black;
      .map-btn,
      .close_btn {
        color: black;
        background-color: white;
      }
    }
  }

  .map-btn {
    font-size: 1.125rem;
    outline: none;
    border: none;
    background-color: black;
    color: white;
    font-weight: 700;
    cursor: pointer;
    &:hover {
      transition: none;
    }
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

const RadioContainer = styled.div`
  width: 40px;
  min-width: 40px;
  display: none;
  align-items: center;
  ${media.md`
    width: 56px;
    min-width: 56px;
    display: flex;
  `}
`

const CardHead = styled.div`
  width: 100%;
  display: flex;
  @media screen and (max-width: ${theme.screenSize.sizeSM}) {
    display: block;
  }
`
const IconContainer = styled.div`
  padding-right: 24px;

  ${media.md`
    padding-right: 50px;
  `}
`

const TextContainer = styled.div``

const Description = styled.div``

const CardOptions = styled.div`
  padding-top: 16px;
  padding-left: 54px;
  width: 100%;

  ${media.md`
    padding-left: 80px;
  `}
`

const SortDropDown = styled(SortDropdown)`
  position: relative;
  /* margin: 20px 0; */
  border-radius: 0;
  border: 1px solid black;
  @media screen and (max-width: ${theme.screenSize.sizeSM}) {
    min-width: 100%;
    .sort-button {
      min-width: 100%;
    }
  }
  .options {
    position: absolute;
    top: 120%;
    border: 1px solid black;
    padding: 10px;
    border-left: 1px solid black !important;
    border-bottom: 1px solid black !important;
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  }
`

export default function CheckoutRadioCard({
  title,
  description,
  price,
  selected = false,
  onSelect,
  icon,
  children,
  showDropDown,
  options,
  droppDelivery,
  droppDeliveryId,
  locationId,
  mapDetail,
  setLocationInfo,
  updateDropDownLocationInfo,
  setSelectedDropLocation,
}: Props): JSX.Element {
  const [optionNum, setOptionNum] = useState(0)
  const [selectedOption, setSelectedOption] = useState<any>(null)

  const [mapSelected, setMapSelected] = useState<boolean>(false)
  const [selectedMapAddress, setSelectedMapAddress] = useState<string>('')

  useEffect(() => {
    if (options && options.length > 0 && optionNum === 0) {
      setSelectedOption(options[0])
      setOptionNum((n) => n + 1)
    }
  }, [optionNum, options])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        dropDownRef.current &&
        !(dropDownRef.current as any).contains(event.target)
      ) {
        setShowDropdown(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const getDetailsFromMapSelection = (): void => {
    if (
      typeof window !== 'undefined' &&
      typeof window.chooseDroppLocation === 'function'
    ) {
      // DroppBoxAPI function to get details from map selection.
      window
        .chooseDroppLocation()
        .then((location: any) => {
          if (location && location.name && location.id) {
            const parsedValues = {
              droppboxName: location.name,
              droppboxId: location.id,
              droppboxLatitude: location.gpsLatitude,
              droppboxLongitude: location.gpsLongitude,
              droppboxAddress: location.address,
            }
            if (locationId) {
              locationId(location)
            }
            if (setLocationInfo) {
              setLocationInfo(parsedValues)
            }
            setSelectedMapAddress(location.address)
            setMapSelected(true)
          } else {
            console.error('Invalid location data:', location)
          }
        })
        .catch((err: any) => {
          console.log(`Got error on map view function --> ${err}`)
        })
    }
  }

  const handleOptionClick = (option: any): void => {
    setSelectedOption(option)
    setShowDropdown(false)
    if (locationId) {
      locationId(option)
    }
  }

  const [showDropdown, setShowDropdown] = useState<boolean>(false)

  const dropDownRef = useRef(null)

  const closeMap = useCallback(() => {
    if (!locationId) return
    setMapSelected(false)
    setSelectedMapAddress('')
    setSelectedOption(options[0])
    locationId(options[0])
  }, [locationId, options])

  return (
    <Wrapper>
      <RadioContainer>
        <RadioButton checked={selected} onChange={onSelect} />
      </RadioContainer>
      <Card className={cn({selected})} onClick={onSelect}>
        <CardHead>
          <IconContainer>{icon}</IconContainer>
          <TextContainer>
            <Title6 withGutter>
              {title} {price && `- ${price}`}
            </Title6>
            <Description>{description}</Description>
            {showDropDown && options && !mapSelected && (
              <div>
                {options.length ? (
                  <SortDropDown ref={dropDownRef}>
                    <button
                      type="button"
                      className="sort-button"
                      onClick={() => setShowDropdown(!showDropdown)}
                    >
                      <span>{selectedOption?.address}</span>
                      <i className={showDropdown ? 'arrow up' : 'arrow down'} />
                    </button>
                    {showDropdown && (
                      <div className="options">
                        <ul>
                          {options?.map((option: any, index: number) =>
                            index <= 5 ? (
                              <li key={option.id}>
                                <button
                                  type="button"
                                  onClick={() => handleOptionClick(option)}
                                >
                                  {option?.address}
                                </button>
                              </li>
                            ) : null,
                          )}
                        </ul>
                      </div>
                    )}
                  </SortDropDown>
                ) : (
                  <Loader />
                )}
              </div>
            )}
            {mapDetail && options && showDropDown && (
              <div className={`btn-container ${mapSelected && 'selected'}`}>
                <button
                  type="button"
                  onClick={getDetailsFromMapSelection}
                  className="map-btn"
                >
                  {selectedMapAddress || 'Velja annan afhendingarstað'}
                </button>
                {mapSelected && (
                  <span className="close_btn" onClick={closeMap}>
                    <CloseLineIcon />
                  </span>
                )}
              </div>
            )}
          </TextContainer>
        </CardHead>
        {!!children && (
          <Expandable expanded={selected}>
            <CardOptions>{children}</CardOptions>
          </Expandable>
        )}
      </Card>
    </Wrapper>
  )
}
